import {JsonView} from './shared'

interface ErrorLogsTabProps {
    record: any
}

function ErrorLogsTab({record}: ErrorLogsTabProps) {
    return (
        <JsonView 
            data={record?.data?.meta?.consoleErrors} 
            placeholder="No error logs" 
        />
    )
}

export default ErrorLogsTab
